<main class="session-error" role="alert">
  <ui-twist-logo height="3em"></ui-twist-logo>
  <h1 class="session-error__title">We couldn't sign you in</h1>
  <p class="session-error__text">
    Your sign-in session is incomplete and logging in again did not repair it.
    Sign out to clear it, then sign in again.
  </p>
  <tw-btn variant="primary" size="md" (click)="signOut.emit()">Sign out</tw-btn>
</main>
